import { FC } from 'react';
import { RadioButton } from '../../../../components/radio-button/radio-button';
import { SortType } from '../../../../types/props';
import s from './table-alphabetic-sort-radio.module.css';

interface Props {
  alphabetDirection: SortType;
  setAlphabetDirection: (value: SortType) => void;
}

export const AlphabeticSortRadio: FC<Props> = ({ alphabetDirection, setAlphabetDirection }) => {
  const isDesc = alphabetDirection === 'desc';
  const isAsc = alphabetDirection === 'asc';

  return (
    <div className={s.feature}>
      <RadioButton
        label="AZ"
        checked={alphabetDirection === 'asc'}
        onClick={() => isDesc && setAlphabetDirection('asc')}
      />
      <RadioButton
        label="ZA"
        checked={alphabetDirection === 'desc'}
        onClick={() => isAsc && setAlphabetDirection('desc')}
      />
    </div>
  );
};
